// Platform features index collection.
import { BRAND_LINKS, buildSupportMailto } from '../../configs/brandLinks';
import { collectionSection, defineCollection, link, list, p, text, } from '../schema';
export const featuresCollection = defineCollection({
    id: 'collection:features',
    kind: 'index',
    route: '/discover/features',
    title: 'Platform Features',
    description: 'Explore customization options, moderation tools, integrations, and other platform features.',
    seo: {
        description: 'Learn about Airhead Games platform features. Explore customization options, moderation tools, integrations, and more.',
    },
    hero: {
        eyebrow: [text('Discover')],
        title: [text('Features')],
        description: [
            text('Customization options, moderation tools, integrations, and more.'),
        ],
        background: 'gradient-card',
        backgroundAccentFamily: 'orange',
        showDescription: true,
    },
    sections: [
        collectionSection({
            id: 'overview',
            title: 'Overview',
            blocks: [
                p([
                    text('Learn about the features that make Airhead Games unique. Each page contains detailed how-to guides and screenshots. If anything is missing or unclear, please contact support via '),
                    link(buildSupportMailto(), 'email'),
                    text(' or '),
                    link(BRAND_LINKS.discord, 'Discord'),
                    text('.'),
                ]),
            ],
        }),
        collectionSection({
            id: 'getting-started',
            title: 'Getting Started',
            blocks: [
                list({
                    items: [
                        [
                            link('/discover/features/login', 'Login Options'),
                            text(' - Authentication, linking Twitch, session timing, and logging out'),
                        ],
                        [
                            link('/discover/features/loons', 'Loons'),
                            text(' - what they are, how to get and use them'),
                        ],
                        [
                            link('/discover/features/achievements', 'Achievements'),
                            text(' - Earn Loons for hosting games and more'),
                        ],
                        [
                            link('/discover/features/twitch', 'Twitch Integration'),
                            text(' - Account linking, permissions, and the features they enable'),
                        ],
                    ],
                }),
            ],
        }),
        collectionSection({
            id: 'in-game-experience',
            title: 'In-Game Experience',
            blocks: [
                list({
                    items: [
                        [
                            link('/discover/features/game-room-lifecycle', 'Game Room Lifecycle'),
                            text(' - Create, join, start, and close game rooms'),
                        ],
                        [
                            link('/discover/features/user-preferences', 'User Preferences'),
                            text(' - Tailor the game experience for your group'),
                        ],
                        [
                            link('/discover/features/moderator-tools', 'Moderator Tools'),
                            text(' - Control player access, content censorship, and Poppy in Twitch chat'),
                        ],
                        [
                            link('/discover/features/audio', 'Audio'),
                            text(' - Controls, effects, and original stream-safe music'),
                        ],
                        [
                            link('/discover/features/poppy', 'Poppy'),
                            text(' - Dynamic host, in-game menu, and Poppy in your chat'),
                        ],
                    ],
                }),
            ],
        }),
    ],
});
//# sourceMappingURL=features.js.map